module.exports = __webpack_public_path__ + "static/media/logo-TAD-d.2b0c2e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-TAD-d.png
// module id = 77
// module chunks = 0